module.exports = __webpack_public_path__ + "d032e890f84a48fde02fffd255039982.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/message_outbound/bound_type/inbound/rich_type/promo/targets/GRANDISPESE2_b.svg
 ** module id = 75
 ** module chunks = 0
 **/